import { N900 } from '@atlaskit/theme/colors';
import { Environment } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useFirstImpressionsState } from '../../use-first-impressions-state';

import { messages } from '../../messages';

export function SlackPromoConfluenceIneligibleFormView() {
  const { userInfo } = useFirstImpressionsState();
  const environment = Environment.getEnvironment();
  let goToMyProductsUrl = 'https://start.stg.atlassian.com/';
  if (environment === 'production') {
    goToMyProductsUrl = 'https://start.atlassian.com/';
  }
  return (
    <SlackPromoConfluenceIneligibleFormViewContainer>
      <FormHeaderContainer>
        <FormHeaderHeading>
          <FormattedMessage
            {...messages.firstImpressionsLoggedInFormHeader}
            values={{
              userName: userInfo?.firstName
            }}
          />
        </FormHeaderHeading>
      </FormHeaderContainer>
      <IneligibleMessageParagraphContainer>
        <IneligibleMessageParagraph>
          <FormattedMessage {...messages.userHasPaidSites} />
        </IneligibleMessageParagraph>
      </IneligibleMessageParagraphContainer>
      <IneligibleMessageLink>
        <a href={goToMyProductsUrl}>
          <FormattedMessage {...messages.goToMyProducts} />
        </a>
      </IneligibleMessageLink>
    </SlackPromoConfluenceIneligibleFormViewContainer>
  );
}

const SlackPromoConfluenceIneligibleFormViewContainer = styled.div`
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

const FormHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const FormHeaderHeading = styled.div`
  color: ${N900};
  font-family: 'Charlie Display';
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  padding-bottom: 24px;
`;

const IneligibleMessageParagraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const IneligibleMessageParagraph = styled.div`
  color: ${N900};
  font-family: 'Charlie Display';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding-bottom: 24px;
  text-align: center;
`;

const IneligibleMessageLink = styled.div`
  color: ${N900};
  font-family: 'Charlie Text';
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 24px;
  text-align: center;
  letter-spacing: 0px;
  & a {
    text-decoration: none;
    font-weight: 400;

    & span:after {
      content: '→';
      margin-left: 4px;
      font-size: 12px;
    }
  }
`;
